import React from 'react';

import { SVGComponentProps } from './svg.types';

const DashedLineSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="24"
        height="33"
        viewBox="0 0 24 33"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="1.5"
          y1="0.5"
          x2="1.5"
          y2="29.5"
          stroke="#D5D7DD"
          strokeLinecap="round"
          strokeDasharray="6 6"
        />
        <path
          d="M23.6667 30C23.6667 28.5272 22.4728 27.3333 21 27.3333C19.5272 27.3333 18.3333 28.5272 18.3333 30C18.3333 31.4728 19.5272 32.6667 21 32.6667C22.4728 32.6667 23.6667 31.4728 23.6667 30ZM1.44444 29.5C1.1683 29.5 0.944445 29.7239 0.944445 30C0.944445 30.2761 1.1683 30.5 1.44444 30.5V29.5ZM18.5556 29.5C18.2794 29.5 18.0556 29.7239 18.0556 30C18.0556 30.2761 18.2794 30.5 18.5556 30.5V29.5ZM13.6667 30.5C13.9428 30.5 14.1667 30.2761 14.1667 30C14.1667 29.7239 13.9428 29.5 13.6667 29.5V30.5ZM8.77778 29.5C8.50164 29.5 8.27778 29.7239 8.27778 30C8.27778 30.2761 8.50164 30.5 8.77778 30.5V29.5ZM3.88889 30.5C4.16503 30.5 4.38889 30.2761 4.38889 30C4.38889 29.7239 4.16503 29.5 3.88889 29.5V30.5ZM21 29.5H18.5556V30.5H21V29.5ZM13.6667 29.5H8.77778V30.5H13.6667V29.5ZM3.88889 29.5L1.44444 29.5V30.5L3.88889 30.5V29.5Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default DashedLineSVG;
